import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import CropSquareIcon from "@mui/icons-material/CropSquare"; // Maximize
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit"; // Minimize
import * as XLSX from "xlsx";
// import CommentIcon from "@mui/icons-material/Comment";
import { Box, Typography, Button, Stack, Avatar, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setIsNewCostSheet } from "..//redux/eventOrganiserSlice";
import CreateCostSheetForm from "./CreateCostSheetForm";

import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./commentBox.css";
import { useLocation, useNavigate } from "react-router-dom";
import { GetActivityDetailsThunk } from "../redux/eventOrganiserThunks";
import axios from "axios";
import {
  WSGetOrgUsers,
  addNewComment,
  generateSummary,
} from "../../../configs/WebService";
import { apiKeyHeader } from "../../../configs/ApiKeys";
import userStore from "../../../zustand/userStore";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import ReplyIcon from "@mui/icons-material/Reply";
import QuotationTable from "./quotation-summary";
import ChecklistSection from "./ChecklistSection";
import Popup from "../Popup";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
// import ChecklistSection from "./ChecklistSection";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  AccessTime,
  MenuBook,
  CalendarMonth,
  EventNote,
  CheckBox,
  InsertDriveFile,
  HelpOutline,
} from "@mui/icons-material";

// Icon and color maps based on value or name
const iconMap = {
  CostSheet: <AccessTime />,
  quotations: <MenuBook />,
  create_documents: <CalendarMonth />,
  checklist: <EventNote />,
  uploaded_records: <CheckBox />,
  teacher_planner: <InsertDriveFile />,
};

const colorMap = {
  CostSheet: "#0094da",
  quotations: "#90be1b",
  create_documents: "#1d4088",
  checklist: "#d65555",
  uploaded_records: "#d6085c",
  teacher_planner: "#de7610",
};

export default function ActivityDetails() {
  const userData = userStore((state) => state.user);
  const { selectedActivity, error, selectedEvent } = useSelector(
    (state) => state.eventOrganiser
  );
  const [quotationFile, setQuotationFile] = useState(null);
  const [overflowStates, setOverflowStates] = useState({});
  const contentRefs = useRef({});

  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [event, setEvent] = useState(null);
  const handleClickOpen = (event) => {
    setEvent(event);
    setOpen(true);
  };
  const [selectedOption, setSelectedOption] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [commentDetails, setCommentDetails] = useState({
    existingComments: selectedActivity?.at(0)?.comments || [],
    comment: "",
    mentionedUsers: [],
    allUsersList: [],
    usersList: [],
    mentionSearchTerm: "",
    showDetails: false,
    files: [],
    replyMessage: { reply_id: "", description: "" },
    summary: [],
    event_id: "",
    show_files: false,
    show_comments: true,
    button_disable: false,
  });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedFile(null);
  };
  const getOrgUsers = () => {
    axios
      .get(WSGetOrgUsers, { headers: apiKeyHeader() })
      .then((response) => {
        const responseData = response.data;
        if (responseData) {
          const users = responseData || [];
          handleCommentDetails("allUsersList", users);
          handleCommentDetails("usersList", users);
        }
      })
      .catch((error) => {
        console.error("getOrgUsers_error", error);
      });
  };

  const handleCommentDetails = (key, value) => {
    setCommentDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  // useEffect(() => {
  //   const newOverflowStates = {};

  //   Object.entries(contentRefs.current).forEach(([idx, ref]) => {
  //     if (ref) {
  //       const height = ref.scrollHeight;
  //       newOverflowStates[idx] = height > window.innerHeight * 0.2; // 20vh
  //     }
  //   });

  //   setOverflowStates(newOverflowStates);
  // }, [commentDetails.existingComments]);
  useEffect(() => {
    const newOverflowStates = {};

    Object.entries(contentRefs.current).forEach(([idx, ref]) => {
      if (ref) {
        const checkOverflow = () => {
          const height = ref.scrollHeight;
          newOverflowStates[idx] = height > window.innerHeight * 0.2;
          setOverflowStates((prev) => ({
            ...prev,
            [idx]: newOverflowStates[idx],
          }));
        };

        // Initial check
        checkOverflow();

        // Attach onload for images
        const imgs = ref.querySelectorAll("img");
        imgs.forEach((img) => {
          img.onload = checkOverflow;
        });
      }
    });
  }, [commentDetails.existingComments]);

  const handleUserMention = (user) => {
    const newMention = `**${user.name}**`;
    const newComment = commentDetails.comment + newMention;

    let updatedMentionedUsers = commentDetails.mentionedUsers.filter((u) =>
      newComment.includes(`**${u.name}**`)
    );

    if (!updatedMentionedUsers.some((u) => u.name === user.name)) {
      updatedMentionedUsers.push({
        id: user.id,
        name: user.name,
      });
    }

    handleCommentDetails("comment", newComment);
    handleCommentDetails("mentionedUsers", updatedMentionedUsers);
  };

  const handleSend = async () => {
    const formData = new FormData();

    if (!commentDetails.comment || commentDetails.comment.length === 0) {
      return alert("Please enter a comment before submitting.");
    }

    commentDetails.files.forEach((each) => {
      formData.append("files", each.file); // backend should expect `files` as array or multiple entries
    });

    // Prepare filesData array
    const filesDataArray = commentDetails.files.map((each) => ({
      file_name: each.file.name,
      category: each.category,
    }));
    formData.append("filesData", JSON.stringify(filesDataArray));

    // Append remaining fields
    formData.append("description", `${commentDetails.comment}`);
    formData.append(
      "mentionedUsers",
      JSON.stringify(commentDetails.mentionedUsers)
    ); // if it's an array/object
    formData.append("createdBy", `${userData?.id}`);
    formData.append(
      "replayId",
      `${commentDetails?.replyMessage?.reply_id || 0}`
    );
    formData.append("eventId", `${commentDetails?.event_id}`);
    formData.append("activityId", `${selectedActivity[0]?.id}`);

    const headers = apiKeyHeader();
    delete headers["content-type"];
    toast.success("Loading ...", {
      autoClose: 50,
    });
    try {
      const response = await fetch(addNewComment, {
        method: "POST",
        headers,
        body: formData,
      });

      if (response.ok) {
        const fetchedData = await response.json();
        alert(fetchedData?.message || "Successfully added the comment");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCancel = () => {
    setCommentDetails((prev) => ({
      ...prev,
      comment: "",
      show_files: false,
    }));
  };
  useEffect(() => {
    if (
      selectedActivity === null &&
      location?.state?.activityId &&
      error === null
    ) {
      const activityId = location.state.activityId;
      dispatch(GetActivityDetailsThunk({ activityId }));
    }
  }, [selectedActivity, location?.state?.activityId, error, dispatch]);

  const openDocumentNew = async (fileUrl, fileName) => {
    try {
      const url = fileUrl
        ? fileUrl.startsWith("https://web1024.docmaster.in:5010")
          ? fileUrl
          : fileUrl.replace(
              "http://localhost:5010",
              "https://web1024.docmaster.in:5010"
            )
        : "";

      const extension = fileName.split(".").pop().toLowerCase();

      // For Excel
      if (extension === "xlsx" || extension === "xls") {
        const response = await axios.get(url, { responseType: "arraybuffer" });
        const data = new Uint8Array(response.data);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        let htmlContent = `<html><head><meta charset="UTF-8"><title>Excel Preview</title></head><body><table border="1" cellpadding="5" cellspacing="0">`;
        parsedData.forEach((row) => {
          htmlContent += "<tr>";
          row.forEach((cell) => {
            htmlContent += `<td>${cell ?? ""}</td>`;
          });
          htmlContent += "</tr>";
        });
        htmlContent += "</table></body></html>";

        const blob = new Blob([htmlContent], { type: "text/html" });
        const blobUrl = URL.createObjectURL(blob);

        return { type: "iframe", url: blobUrl };
      }

      // For Word, PPT, and other docs
      else if (["doc", "docx", "ppt", "pptx"].includes(extension)) {
        const encodedUrl = encodeURIComponent(url);
        return {
          type: "iframe",
          url: `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`,
        };
      }

      // For PDFs
      else if (extension === "pdf") {
        return { type: "iframe", url };
      }

      // For images
      else if (
        ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)
      ) {
        return { type: "image", url };
      }

      // Fallback
      else {
        window.open(url, "_blank");
        return { type: "iframe", url }; // still return something valid
      }
    } catch (err) {
      console.error("Error in openDocumentNew:", err);
      return { type: "iframe", url: "" }; // fallback safe response
    }
  };

  useEffect(() => {
    const prepareFilteredData = async () => {
      if (!Array.isArray(selectedActivity) || !selectedActivity[0]) return;

      const baseData = [
        // Comments
        ...(Array.isArray(selectedActivity[0].comments)
          ? selectedActivity[0].comments.map((c) => ({
              ...c,
              type: "comment",
              mentioned_users: Array.isArray(c.mentioned_users)
                ? c.mentioned_users
                : c.mentioned_users
                ? [c.mentioned_users]
                : [],
              created_by: c.created_by,
            }))
          : []),

        // Docform Docs
        ...(Array.isArray(selectedActivity[0].docformDocs)
          ? selectedActivity[0].docformDocs.map((d) => ({
              ...d,
              type: "comment",
              created_by: d.user_id,
              docForm: (
                <p className="mb-0">
                  {d.form_name && "Created a document : "}

                  <span
                    onClick={() => {
                      handleClickOpen(d);
                      setSelectedOption("create_documents");
                    }}
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      lineHeight: "1.1",
                    }}
                  >
                    {d.form_name || "-"}
                  </span>
                </p>
              ),
            }))
          : []),

        // Uploads
        ...(Array.isArray(selectedActivity[0].uploads)
          ? selectedActivity[0].uploads.map((d) => ({
              ...d,
              type: "comment",
              created_by: d.user_id,
              fileCategory: d.category || "",
              description: "",
              // uploadedFile will be resolved later
            }))
          : []),
      ];

      // Add iframe content to uploads
      const uploadsWithIframes = await Promise.all(
        baseData.map(async (item) => {
          if (item.url && item.file_name) {
            try {
              const { type, url } = await openDocumentNew(
                item.url,
                item.file_name
              );
              return {
                ...item,
                uploadedFile:
                  type === "image" ? (
                    <img
                      src={url.replace(
                        "http://localhost:5010",
                        "https://web1024.docmaster.in:5010"
                      )}
                      alt="file not found"
                      style={{
                        width: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <iframe
                      title="quotation file"
                      src={url}
                      style={{
                        width: "100%",
                        height: "500px",
                        border: "none",
                      }}
                    />
                  ),
              };
            } catch (err) {
              console.error("Failed to open document:", err);
              return item; // fallback
            }
          }
          return item;
        })
      );

      const sorted = uploadsWithIframes.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      setCommentDetails((prev) => ({
        ...prev,
        existingComments: sorted,
        event_id: selectedActivity?.[0]?.event_id,
      }));
    };

    // ✅ Call the async function inside the effect
    if (selectedActivity !== null) {
      prepareFilteredData();
    }
  }, [selectedActivity]);

  useEffect(() => {
    getOrgUsers();
  }, []);

  const getMentionedUserNamesNew = (users) => {
    if (Array.isArray(users)) return users.map((u) => u.name).join(", ");
    if (typeof users === "object" && users !== null) return users.name || "";

    return "";
  };

  const noteSheetList = [
    { name: "Create / View Cost Sheets", value: "CostSheet" },
    { name: "Quotations", value: "quotations" },
    { name: "Create Documents", value: "create_documents" },
    { name: "Checklist", value: "checklist" },
    { name: "Uploaded Records", value: "uploaded_records" },
    ...(commentDetails.existingComments?.length > 0
      ? commentDetails.existingComments.map((each, index) => ({
          name: (
            // <div className="d-flex   gap-2" key={index}>
            //   <div className="d-flex flex-1 w-100">
            //     <div
            //       className="w-100 shadow-sm"
            //       style={{
            //         backgroundColor: "#f1f5f9", // light gray background like the screenshot
            //         border: "none",
            //         height: "15vh",
            //         // overflow: expandedIndex && "auto",
            //         padding: "15px",
            //         marginBottom: "2%",
            //         borderRadius: "12px", // more rounded
            //         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)", // subtle shadow
            //       }}
            //     >
            //       <p
            //         style={{
            //           display: "flex",
            //           alignItems: "center",
            //           justifyContent: "space-between",
            //           cursor: "pointer",
            //           lineHeight: "1.2",
            //         }}
            //       >
            //         <span
            //           style={{
            //             display: "flex",
            //             alignItems: "center",
            //             gap: "10px",
            //           }}
            //         >
            //           <b
            //             className="text-primary"
            //             style={{
            //               color: "#2563eb", // Tailwind blue-600
            //               fontSize: "16px",
            //             }}
            //           >
            //             {
            //               commentDetails?.allUsersList?.find(
            //                 (e) => e.id === Number(each.created_by)
            //               )?.name
            //             }
            //           </b>
            //           <span
            //             className="text-14"
            //             style={{
            //               color: "#6b7280", // gray-500
            //               fontSize: "14px",
            //             }}
            //           >
            //             {new Date(each.created_at).toLocaleString([], {
            //               year: "numeric",
            //               month: "short",
            //               day: "2-digit",
            //               hour: "2-digit",
            //               minute: "2-digit",
            //             })}
            //           </span>
            //         </span>

            //         <IconButton
            //           title="Reply"
            //           onClick={() => {
            //             setCommentDetails((prev) => ({
            //               ...prev,
            //               replyMessage: {
            //                 reply_id: each?.id,
            //                 description: each.description,
            //               },
            //             }));
            //             const textarea =
            //               document.getElementById("commentTextarea");
            //             if (textarea) {
            //               textarea.scrollIntoView({ behavior: "smooth" });
            //               textarea.focus();
            //             }
            //           }}
            //         >
            //           <ReplyIcon />
            //         </IconButton>
            //       </p>
            //       {each?.replay_details ? (
            //         <p
            //           style={{
            //             backgroundColor: "rgb(243,246,247)",
            //             padding: "0px",
            //             width: "70%",
            //             fontSize: "14px",
            //             borderRadius: "4px",
            //             marginLeft: "2%",
            //             lineHeight: "1.2",
            //           }}
            //         >
            //           {each?.replay_details?.at(0)?.description}
            //         </p>
            //       ) : (
            //         ""
            //       )}

            //       <p
            //         className="text-primary text-14"
            //         style={{ marginLeft: "2%" }}
            //       >
            //         {each.mentioned_users?.length > 0 && (
            //           <p>
            //             {/* <strong>Mentioned Users</strong> */}
            //             {getMentionedUserNamesNew(
            //               JSON.parse(each.mentioned_users)
            //             )}
            //           </p>
            //         )}
            //       </p>
            //       <p
            //         className="mb-0"
            //         style={{ fontSize: "14px", marginLeft: "2%" }}
            //       >
            //         {expandedIndex === index
            //           ? each.description.slice(0, 90)
            //           : each.description}
            //       </p>

            //       <p>
            //         {" "}
            //         {each.fileCategory
            //           ? `Uploaded a file under ${each.fileCategory} category`
            //           : ""}
            //       </p>
            //       {each?.files?.length > 0 ||
            //         each.docForm ||
            //         (each.fileCategory && (
            //           <KeyboardArrowDownIcon
            //             style={{
            //               cursor: "pointer",
            //               marginLeft: "50%",
            //               color: expandedIndex !== index ? "#2563eb" : "black",
            //               transition: "transform 0.3s ease",
            //               transform:
            //                 expandedIndex === index
            //                   ? "rotate(180deg)"
            //                   : "rotate(0deg)",
            //             }}
            //             onClick={() =>
            //               setExpandedIndex((prev) =>
            //                 prev === index ? null : index
            //               )
            //             }
            //           />
            //         ))}
            //       {expandedIndex === index ? (
            //         <div>
            //           {each.docForm}
            //           {each.fileCategory}
            //           {each.uploadedFile && (
            //             <div style={{ marginTop: "10px" }}>
            //               {" "}
            //               {each.uploadedFile}
            //             </div>
            //           )}
            //           {each?.files?.length > 0 &&
            //             each.files.map((file, index) => (
            //               <div>
            //                 Attachment (s)
            //                 <div
            //                   key={index}
            //                   style={{
            //                     fontSize: "30px",
            //                     cursor: "pointer",
            //                     display: "inline-block",
            //                     marginRight: "8px",
            //                   }}
            //                   onClick={() => window.open(file.url, "_blank")}
            //                   title={file.name || "Open file"}
            //                 >
            //                   📄
            //                 </div>
            //               </div>
            //             ))}
            //         </div>
            //       ) : (
            //         <></>
            //       )}
            //     </div>
            //   </div>
            // </div>
            <div className="d-flex gap-2" key={index}>
              <div className="d-flex flex-1 w-100">
                <div
                  className="w-100 shadow-sm"
                  style={{
                    backgroundColor: "#f1f5f9",
                    border: "none",
                    padding: "15px",
                    // marginBottom: "2%",
                    borderRadius: "12px",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  {each.created_at ? (
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        marginBottom: "0px",
                        // lineHeight: "1.2",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <b
                          className="text-primary"
                          style={{ color: "#2563eb", fontSize: "16px" }}
                        >
                          {
                            commentDetails?.allUsersList?.find(
                              (e) => e.id === Number(each.created_by)
                            )?.name
                          }
                        </b>
                        <span
                          className="text-14"
                          style={{ color: "#6b7280", fontSize: "14px" }}
                        >
                          {each.created_at &&
                            new Date(each.created_at).toLocaleString([], {
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                        </span>
                      </span>

                      {each.created_at && (
                        <IconButton
                          className="p-0"
                          title="Reply"
                          onClick={() => {
                            setCommentDetails((prev) => ({
                              ...prev,
                              replyMessage: {
                                reply_id: each?.id,
                                description: each.description,
                              },
                            }));
                            const textarea =
                              document.getElementById("commentTextarea");
                            if (textarea) {
                              textarea.scrollIntoView({ behavior: "smooth" });
                              textarea.focus();
                            }
                          }}
                        >
                          <ReplyIcon />
                        </IconButton>
                      )}
                    </p>
                  ) : (
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                        marginBottom: "0px",
                        color: "#F2473D",
                        textAlign: "center",
                        paddingLeft: "40%",
                        // lineHeight: "1.2",
                      }}
                    >
                      No Comments found
                    </p>
                  )}

                  {each?.replay_details ? (
                    <p
                      className="mb-0"
                      style={{
                        backgroundColor: "rgb(243,246,247)",
                        padding: "0px",
                        width: "70%",
                        fontSize: "14px",
                        borderRadius: "4px",
                        marginLeft: "2%",
                        lineHeight: "1.2",
                      }}
                    >
                      {each?.replay_details?.[0]?.description}
                    </p>
                  ) : null}

                  {each.mentioned_users?.length > 0 ? (
                    <p
                      className="text-primary text-14 mb-0"
                      style={{ marginLeft: "2%" }}
                    >
                      {getMentionedUserNamesNew(
                        JSON.parse(each.mentioned_users)
                      )}
                    </p>
                  ) : null}

                  <div
                    ref={(el) => (contentRefs.current[index] = el)}
                    style={{
                      maxHeight: expandedIndex === index ? "none" : "20vh",
                      overflow: expandedIndex === index ? "visible" : "hidden",
                      transition: "max-height 0.3s ease",
                    }}
                  >
                    {each.description ? (
                      <p
                        className="mb-0"
                        style={{ fontSize: "14px", marginLeft: "2%" }}
                      ></p>
                    ) : null}
                    {each.fileCategory ? (
                      <p>
                        Uploaded a file under{" "}
                        <strong>{each.fileCategory}</strong> category
                      </p>
                    ) : (
                      ""
                    )}

                    {each.docForm}
                    {each.uploadedFile && (
                      <div style={{ marginTop: "10px" }}>
                        {each.uploadedFile}
                      </div>
                    )}

                    {each?.files?.length > 0 &&
                      each.files.map((file, i) => (
                        <div key={i}>
                          Attachment (s)
                          {/* {JSON.stringify(file)} */}
                          <strong> {file.file_name} </strong>
                          <div
                            style={{
                              fontSize: "30px",
                              cursor: "pointer",
                              display: "inline-block",
                              marginRight: "8px",
                            }}
                            // onClick={() => window.open(file.url, "_blank")}
                            onClick={() => {
                              openDocument(file.url, file.file_name);
                            }}
                            title={file.name || "Open file"}
                          >
                            📄
                          </div>
                        </div>
                      ))}
                  </div>

                  {/* Show Arrow Only If Overflow Detected */}
                  {overflowStates[index] && (
                    <KeyboardArrowDownIcon
                      style={{
                        cursor: "pointer",
                        marginLeft: "50%",
                        color: expandedIndex !== index ? "#2563eb" : "black",
                        transition: "transform 0.3s ease",
                        transform:
                          expandedIndex === index
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                      }}
                      onClick={() =>
                        setExpandedIndex((prev) =>
                          prev === index ? null : index
                        )
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          ),
          value: "comment",
          description: each.description,
        }))
      : []),
  ];

  // const uploads = selectedActivity?.[0]?.uploads || [];
  const uploads = selectedActivity?.[0]?.uploads || [];
  const documents = selectedActivity?.[0]?.docformDocs || [];
  const quotation_uploads =
    uploads.filter((each) => each.category === "Quotations") || [];

  const isNewCostSheet = useSelector(
    (state) => state.eventOrganiser.isNewCostSheet
  );

  const parseAssignedUsers = (usersStr) => {
    try {
      const users = JSON.parse(usersStr);
      return users.map((user) => user.name).join(", ");
    } catch {
      return "";
    }
  };

  const dataItemTableColumns = [
    {
      Header: "Sl no",
      accessor: "sno",
    },
    {
      Header: "File Name",
      accessor: "fileName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Category",
      accessor: "category",
    },

    // {
    //   Header: "Actions",
    //   accessor: "action",
    // },
  ];

  const tableData = [
    {
      Header: "Sl no",
      accessor: "sno",
    },
    {
      Header: "File Name",
      accessor: "fileName",
    },
    {
      Header: "Created At",
      accessor: "created_at",
    },
  ];
  // const openDocument = (fileUrl, fileName) => {
  //   console.log("fileUrl", fileUrl);
  //   const url = fileUrl
  //     ? fileUrl.startsWith("https://web1024.docmaster.in:5010")
  //       ? fileUrl
  //       : fileUrl.replace(
  //           "http://localhost:5010",
  //           "https://web1024.docmaster.in:5010"
  //         )
  //     : "";

  //   const extension = fileName.split(".").pop().toLowerCase();
  //   const encodedUrl = encodeURIComponent(url);

  //   let viewerUrl = "";

  //   if (["doc", "docx", "ppt", "pptx", ".jpg"].includes(extension)) {
  //     viewerUrl = `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
  //   } else if (["xls", "xlsx"].includes(extension)) {
  //     viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
  //   } else if (extension === "pdf") {
  //     viewerUrl = url;
  //   } else {
  //     // fallback: download
  //     viewerUrl = url;
  //   }

  //   setOpen(true);
  //   console.log("viewerUrl", viewerUrl);
  //   setQuotationFile(viewerUrl);
  //   // window.open(viewerUrl, "_blank");
  // };
  const openDocument = async (fileUrl, fileName) => {
    console.log("fileUrl", fileUrl);

    try {
      const url = fileUrl
        ? fileUrl.startsWith("https://web1024.docmaster.in:5010")
          ? fileUrl
          : fileUrl.replace(
              "http://localhost:5010",
              "https://web1024.docmaster.in:5010"
            )
        : "";

      const extension = fileName.split(".").pop().toLowerCase();

      let viewer = { type: "iframe", url: "" };

      // Excel
      if (extension === "xlsx" || extension === "xls") {
        const response = await axios.get(url, { responseType: "arraybuffer" });
        const data = new Uint8Array(response.data);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        let htmlContent = `<html><head><meta charset="UTF-8"><title>Excel Preview</title></head><body><table border="1" cellpadding="5" cellspacing="0">`;
        parsedData.forEach((row) => {
          htmlContent += "<tr>";
          row.forEach((cell) => {
            htmlContent += `<td>${cell ?? ""}</td>`;
          });
          htmlContent += "</tr>";
        });
        htmlContent += "</table></body></html>";

        const blob = new Blob([htmlContent], { type: "text/html" });
        const blobUrl = URL.createObjectURL(blob);
        viewer = { type: "iframe", url: blobUrl };
      }

      // Word/PPT
      else if (["doc", "docx", "ppt", "pptx"].includes(extension)) {
        const encodedUrl = encodeURIComponent(url);
        viewer = {
          type: "iframe",
          url: `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`,
        };
      }

      // PDF
      else if (extension === "pdf") {
        viewer = { type: "iframe", url };
      }

      // Images
      else if (
        ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)
      ) {
        viewer = { type: "image", url };
      }

      // Fallback
      else {
        window.open(url, "_blank");
        viewer = { type: "iframe", url };
      }

      // Set state after preparing viewer
      setOpen(true);
      setQuotationFile(viewer.url);
      console.log("viewerUrl", viewer.url);

      return viewer;
    } catch (err) {
      console.error("Error in openDocument:", err);
      return { type: "iframe", url: "" };
    }
  };

  const processData = (eventsArray) => {
    let serial = 1;
    const rows = [];

    eventsArray.forEach((event) => {
      rows.push({
        sno: serial++,
        fileName:
          (
            <span
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                openDocument(event.url, event.file_name);
              }}
            >
              {" "}
              {event.file_name}
            </span>
          ) || "-",
        description: event.description || "-",
        category: event.category || "-",
      });
    });

    return rows;
  };

  const processData2 = (eventsArray) => {
    let serial = 1;
    const rows = [];

    eventsArray.forEach((event) => {
      rows.push({
        sno: serial++,
        // fileName: event.form_name || "-",
        fileName: (
          <span
            onClick={() => handleClickOpen(event)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {event.form_name || "-"}
          </span>
        ),
        created_at: new Date(event.created_at).toLocaleString([], {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }),
        // created_by: getMentionedUserNames(event.created_by),
      });
    });

    return rows;
  };

  if (error !== null) {
    return (
      <Typography>
        {" "}
        Error Getting Activity Details -- {error.message}
      </Typography>
    );
  }

  if (!selectedActivity) {
    return <Typography>No activity selected</Typography>;
  }

  // const handleFileChange = async () => {
  const handleFileChange = async () => {
    // setShowPopup(true);

    const quotation_uploads_urls = uploads
      .filter((each) => each.category === "Quotations")
      .flatMap((each) => each.url);
    const formData = new FormData();
    const headers = apiKeyHeader();
    delete headers["content-type"];
    const loader = toast.loading("Generating summary...");
    try {
      setCommentDetails((prev) => ({
        ...prev,
        button_disable: true,
      }));
      // Download each URL and append the blob as a File to FormData
      for (const url of quotation_uploads_urls) {
        const response = await fetch(url);
        const blob = await response.blob();
        // Extract filename from URL (fallback to "file")
        const urlParts = url.split("/");
        const filename = urlParts[urlParts.length - 1] || "file";
        formData.append("files", new File([blob], filename));
      }
      const response = await fetch(generateSummary, {
        method: "POST",
        headers,
        body: formData,
      });
      if (response.ok) {
        const fetchedData = await response.json();
        setCommentDetails((prev) => ({
          ...prev,
          summary: fetchedData,
          button_disable: false,
        }));
        setShowPopup(true);
        await toast.dismiss(loader);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="main_container">
      <button
        style={{
          border: "none",
          padding: "10px",
          backgroundColor: "rgba(25,118,210,255)",
          color: "white",
          borderRadius: "10px",
          marginBottom: "2%",
        }}
        onClick={() => window.history.back()}
      >
        Go Back
      </button>
      <br />
      {/* <Sidebar />
      <Navbar /> */}
      <div className="right_col" role="main" style={{ overflow: "auto" }}>
        <Box sx={{}}>
          {/* <Divider sx={{ mb: 3 }} /> */}
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            gap={2}
          >
            {commentDetails.show_comments && (
              <Box
                sx={{
                  overflowX: "auto",
                  width: "50%",
                  // width: commentDetails.show_comments ? "60%" : "50%",
                  padding: "0px",
                }}
              >
                {" "}
                <Typography variant="h5" color="primary" gutterBottom>
                  Activity: {selectedActivity?.[0]?.name}
                </Typography>
                <div style={{ display: "flex", gap: "2%" }}>
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    <strong>Description:</strong>{" "}
                    {selectedActivity?.[0]?.description}
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <strong>Assigned Users:</strong>{" "}
                    {parseAssignedUsers(selectedActivity?.[0]?.assigned_users)}
                  </Typography>
                </div>
                <div
                  className="comment-boxc bg-white rounded-lg p-3 shadow w-100"
                  style={{ borderRadius: "10px" }}
                >
                  <Timeline
                    position="right"
                    sx={{
                      [`& .MuiTimelineItem-root::before`]: {
                        flex: 0,
                        padding: 0,
                      },
                    }}
                  >
                    {/* {noteSheetList.map(({ name, value }, index) => ( */}
                    {noteSheetList
                      .filter(({ value }) => value === "comment")
                      .map(({ name, value }, index, filteredArray) => (
                        <TimelineItem key={index}>
                          <TimelineSeparator>
                            <TimelineDot color="primary">
                              {value === "comment" ? (
                                <Avatar className="avatar-icon bg-transparent p-0" />
                              ) : null}
                            </TimelineDot>
                            {index < noteSheetList.length - 1 && (
                              <TimelineConnector />
                            )}
                          </TimelineSeparator>

                          <TimelineContent className="">
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <div
                                key={index}
                                direction="row "
                                className="w-100"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                {value === "comment" && (
                                  <div className="w-100 ">{name} </div> // Comment JSX is already inside `name`
                                )}
                              </div>
                            </Stack>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                  {commentDetails?.replyMessage?.description && (
                    <div className="reply-box" style={{ display: "flex" }}>
                      Reply to:
                      <textarea
                        value={commentDetails.replyMessage.description}
                        disabled
                      />
                      <CloseIcon
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() =>
                          setCommentDetails((p) => ({
                            ...p,
                            replyMessage: { reply_id: "", description: "" },
                          }))
                        }
                      />
                    </div>
                  )}
                  <textarea
                    id="commentTextarea"
                    placeholder="Write a comment..."
                    value={commentDetails.comment}
                    onChange={(e) =>
                      handleCommentDetails("comment", e.target.value)
                    }
                    onFocus={() =>
                      setCommentDetails((p) => ({ ...p, show_files: true }))
                    }
                    style={{
                      border: "0.5px solid #c7c8cc",
                      borderRadius: 10,
                      padding: 10,
                      width: "100%",
                    }}
                  />
                  {commentDetails.show_files && (
                    <>
                      <div className="options-row">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            document.getElementById("fileInput").click()
                          }
                        >
                          📎 File
                        </span>
                        <input
                          id="fileInput"
                          type="file"
                          multiple
                          hidden
                          onChange={(e) => {
                            const files = Array.from(e.target.files || []);
                            handleCommentDetails("files", [
                              ...(commentDetails.files || []),
                              ...files.map((f) => ({
                                file: f,
                                category: "General",
                              })),
                            ]);
                          }}
                        />
                        <span
                          onClick={() =>
                            handleCommentDetails(
                              "showDetails",
                              !commentDetails.showDetails
                            )
                          }
                          style={{
                            cursor: "pointer",
                            color: commentDetails.showDetails ? "blue" : "",
                          }}
                        >
                          @ Mention
                        </span>
                        {commentDetails.showDetails && (
                          <div className="mention-popup">
                            <input
                              type="text"
                              placeholder="search"
                              value={commentDetails.mentionSearchTerm}
                              onChange={(e) => {
                                const value = e.target.value;
                                handleCommentDetails(
                                  "mentionSearchTerm",
                                  value
                                );
                                const filteredUsers = value
                                  ? commentDetails.allUsersList.filter(
                                      (usr) =>
                                        usr.uname
                                          .toLowerCase()
                                          .includes(value.toLowerCase()) ||
                                        usr.name
                                          .toLowerCase()
                                          .includes(value.toLowerCase())
                                    )
                                  : commentDetails.allUsersList;
                                handleCommentDetails(
                                  "usersList",
                                  filteredUsers
                                );
                              }}
                              className="mention-search"
                            />

                            <div className="mention-user-list">
                              {commentDetails.usersList.map((user) => (
                                <div
                                  key={user.id}
                                  className="mention-item"
                                  onClick={() => handleUserMention(user)}
                                >
                                  <span className="mention-avatar">
                                    <AccountCircleIcon />
                                  </span>
                                  <span>{user.name}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      {commentDetails.files?.length > 0 && (
                        <div className="file-preview">
                          {commentDetails.files.map((item, i) => (
                            <div key={i} className="file-card">
                              <div
                                onClick={(e) => (
                                  e.stopPropagation(),
                                  setAnchorEl(e.currentTarget),
                                  setSelectedFile(item.file)
                                )}
                              >
                                {item.file.type.startsWith("image/") ? (
                                  <img
                                    src={URL.createObjectURL(item.file)}
                                    alt={item.file.name}
                                    className="file-image"
                                  />
                                ) : (
                                  <div style={{ fontSize: "30px" }}>📄</div>
                                )}
                              </div>
                              <div className="file-name">{item.file.name}</div>
                              <div className="file-size">
                                {(item.file.size / 1024).toFixed(1)} KB
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "1rem",
                                  fontSize: "13px",
                                }}
                              >
                                <strong>Category:</strong>
                                {["General", "Quotations"].map((cat) => (
                                  <label
                                    key={cat}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.25rem",
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name={`category-${i}`}
                                      value={cat}
                                      checked={item.category === cat}
                                      onChange={(e) => {
                                        const updated = [
                                          ...commentDetails.files,
                                        ];
                                        updated[i].category = e.target.value;
                                        handleCommentDetails("files", updated);
                                      }}
                                    />
                                    {cat}
                                  </label>
                                ))}
                              </div>

                              <button
                                onClick={() =>
                                  handleCommentDetails(
                                    "files",
                                    commentDetails.files.filter(
                                      (_, j) => j !== i
                                    )
                                  )
                                }
                                className="delete-btn"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                          >
                            <MenuItem disabled>
                              File Name: {selectedFile?.name}
                            </MenuItem>
                            <MenuItem disabled>
                              File size:{" "}
                              {(selectedFile?.size / 1024).toFixed(1)} KB
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                window.open(
                                  URL.createObjectURL(selectedFile),
                                  "_blank"
                                )
                              }
                            >
                              Preview
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                const url = URL.createObjectURL(selectedFile);
                                const link = document.createElement("a");
                                link.href = url;
                                link.download = selectedFile.name;
                                link.click();
                                handleMenuClose();
                              }}
                            >
                              Download
                            </MenuItem>
                          </Menu>
                        </div>
                      )}
                      <div className="footer">
                        <Button variant="contained" onClick={handleSend}>
                          SEND
                        </Button>
                        <Button onClick={handleCancel}>CANCEL</Button>
                      </div>
                    </>
                  )}
                </div>
              </Box>
            )}
            {selectedOption !== "" ? (
              <Box
                flex={1}
                style={{
                  backgroundColor: "white",
                  // width: "200%",
                  // height: commentDetails.show_comments ? "50vh" : "70vh",
                  overflowY: "auto",
                  // border: "0.5px solid black",
                  padding: "5px",
                  marginLeft: "0px",
                }}
              >
                <div style={{ display: "flex", float: "right" }}>
                  <IconButton
                    style={{}}
                    onClick={() =>
                      setCommentDetails((prev) => ({
                        ...prev,
                        show_comments: !prev.show_comments,
                      }))
                    }
                  >
                    <Tooltip
                      title={
                        commentDetails.show_comments ? "Maximise" : "Minimise"
                      }
                    >
                      {commentDetails.show_comments ? (
                        <CropSquareIcon />
                      ) : (
                        <FullscreenExitIcon />
                      )}
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    style={{ cursor: "pointer", color: "red" }}
                    onClick={() => {
                      setSelectedOption("");
                      setCommentDetails((prev) => ({
                        ...prev,
                        show_comments: true,
                      }));
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
                {selectedOption !== "CostSheet" &&
                selectedOption !== "create_documents" ? (
                  <h2 style={{ textAlign: "center", fontSize: "18px" }}>
                    <strong>
                      {
                        noteSheetList.find((e) => e.value === selectedOption)
                          .name
                      }
                    </strong>
                  </h2>
                ) : (
                  <h2 style={{ textAlign: "left", fontSize: "18px" }}>
                    <strong>
                      {selectedOption === "create_documents"
                        ? "Create Documents"
                        : "Cost Sheet"}
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          selectedOption === "create_documents"
                            ? navigate("/myDocuments", {
                                state: {
                                  eventId: selectedEvent?.id || null,
                                  activityId:
                                    selectedActivity?.at(0)?.id || null,
                                },
                              })
                            : dispatch(setIsNewCostSheet(true));
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </strong>
                  </h2>
                )}

                {selectedOption === "CostSheet" && (
                  <>
                    <div style={{ padding: "15px" }}>
                      <AllFeatureDataTable
                        columns={[
                          { Header: "Sl no", accessor: "sno" },
                          { Header: "Title", accessor: "title" },
                          { Header: "Description", accessor: "description" },
                        ]}
                        data={
                          selectedActivity[0]?.cost_sheets?.length > 0
                            ? selectedActivity[0]?.cost_sheets?.map(
                                (sheet, index) => {
                                  const modifiedSheet = {
                                    ...sheet,
                                    id: sheet.cost_sheet_id,
                                  };
                                  delete modifiedSheet.cost_sheet_id;
                                  console.log("modifiedSheet", modifiedSheet);

                                  return {
                                    sno: index + 1,
                                    title: (
                                      <p
                                        style={{
                                          cursor: "pointer",
                                          color: "blue",
                                        }}
                                        onClick={() => {
                                          let masterItem = {
                                            title: "BOQ",
                                            code: "boq_bom",
                                            price: 0,
                                          };
                                          navigate("/costingAddItems", {
                                            state: {
                                              masterItem: masterItem,
                                              costingSheet: modifiedSheet,
                                              type: "forMasterItem",
                                            },
                                          });
                                        }}
                                      >
                                        {" "}
                                        {sheet.title}
                                      </p>
                                    ),
                                    description: sheet.details,
                                  };
                                }
                              )
                            : []
                        }
                      />
                    </div>
                  </>
                )}

                {selectedOption === "uploaded_records" &&
                  uploads &&
                  uploads.length > 0 && (
                    <div style={{ padding: "15px" }}>
                      {uploads.filter((each) => each.category !== "Quotations")
                        ?.length > 0 && (
                        <AllFeatureDataTable
                          columns={[
                            {
                              Header: "Sl no",
                              accessor: "sno",
                            },
                            {
                              Header: "File Name",
                              accessor: "fileName",
                            },
                            {
                              Header: "Category",
                              accessor: "category",
                            },
                          ]}
                          data={processData(
                            uploads.filter(
                              (each) => each.category !== "Quotations"
                            )
                          )}
                        />
                      )}
                    </div>
                  )}
                {selectedOption === "quotations" &&
                  quotation_uploads?.length > 0 && (
                    <div style={{ padding: "15px" }}>
                      <button
                        className="btn btn-outline-primary"
                        disabled={commentDetails.button_disable}
                        style={{
                          color: commentDetails.button_disable && "gray",
                          border:
                            commentDetails.button_disable && "1px solid gray",
                        }}
                        // onClick={() => fileInputRef.current?.click()}
                        onClick={handleFileChange}
                      >
                        Generate Summary
                      </button>
                      {quotation_uploads?.length > 0 && (
                        <AllFeatureDataTable
                          columns={dataItemTableColumns}
                          data={processData(quotation_uploads)}
                        />
                      )}
                    </div>
                  )}
                {selectedOption === "create_documents" &&
                  documents &&
                  documents.length > 0 && (
                    <div style={{ marginLeft: "20px", marginRight: "20px" }}>
                      <AllFeatureDataTable
                        columns={tableData}
                        data={processData2(documents)}
                      />
                    </div>
                  )}
                {selectedOption === "checklist" && (
                  <div style={{ marginLeft: "20px", marginRight: "20px" }}>
                    <ChecklistSection />
                  </div>
                )}
              </Box>
            ) : (
              <Timeline
                position="right"
                sx={{
                  [`& .MuiTimelineItem-root::before`]: { flex: 0, padding: 0 },
                }}
              >
                {/* {noteSheetList.map(({ name, value }, index) => ( */}
                {noteSheetList
                  .filter(({ value }) => value !== "comment")
                  .map(({ name, value }, index, filteredArray) => {
                    const icon = iconMap[value] || <HelpOutline />;
                    const bgColor = colorMap[value] || "#888888";

                    return (
                      <TimelineItem key={index}>
                        <TimelineSeparator>
                          <TimelineDot
                            style={{ backgroundColor: "#fff", color: "black" }}
                          >
                            {icon}
                          </TimelineDot>
                          {index < filteredArray.length - 1 && (
                            <TimelineConnector />
                          )}
                        </TimelineSeparator>

                        <TimelineContent>
                          <div
                            onClick={() => setSelectedOption(value)}
                            style={{
                              backgroundColor: bgColor,
                              borderRadius: "9999px",
                              padding: "12px 20px",
                              color: "#fff",
                              fontWeight: "bold",
                              cursor: "pointer",
                              transition: "all 0.2s ease-in-out",
                              transform:
                                selectedOption === value
                                  ? "scale(1.02)"
                                  : "scale(1)",
                              opacity: selectedOption === value ? 1 : 0.85,
                            }}
                          >
                            {name}
                          </div>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  })}
              </Timeline>
            )}
          </Box>
        </Box>

        {isNewCostSheet && (
          <Popup
            title={"Create A New CostSheet"}
            minHeight="400px"
            maxWidth="800px"
            jsustifyContent="center"
            onClose={() => dispatch(setIsNewCostSheet(false))}
          >
            <CreateCostSheetForm selectedActivity={selectedActivity} />
          </Popup>
        )}
        {open && (
          <Popup
            title={
              selectedOption === "create_documents"
                ? "Created Document"
                : "Uploaded File"
            }
            minHeight="350px"
            maxWidth="800px"
            jsustifyContent="center"
            onClose={() => setOpen(false)}
          >
            {selectedOption === "create_documents" ? (
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "50px",
                  maxHeight: "400px",
                  overflowY: "auto",
                  backgroundColor: "#f9f9f9",
                  marginLeft: "25px",
                  marginRight: "25px",
                }}
              >
                <div
                  style={{}}
                  dangerouslySetInnerHTML={{ __html: event.form_data }}
                />
              </div>
            ) : (
              <iframe
                src={quotationFile}
                style={{ width: "100%", height: "500px", border: "none" }}
              />
            )}
          </Popup>
        )}
        {showPopup && (
          <Popup
            title={" Quotations Summary"}
            minHeight="400px"
            maxWidth="800px"
            overflow="auto"
            onClose={() => setShowPopup(false)}
          >
            <div
              style={{
                height: "70vh",
              }}
            >
              <QuotationTable data={commentDetails?.summary} />
            </div>
          </Popup>
        )}
      </div>
      {/* <Footer /> */}
    </div>
  );
}
